module.exports = __webpack_public_path__ + "img/logo-reduzido-gradiente-3x.dd75662e.png";